import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FeatureFlagsService } from "../../../../services/internal-services/feature-flags.service";
import { CollectionProjectSharedTimelineComponent } from "../../base/timeline/collection-project-shared-timeline.component";
import { MapService } from "../../../../services/internal-services/map.service";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-collections-timeline",
  templateUrl: "../../collections/collections-timeline.component.html",
  styleUrls: ["../../base/timeline/base-timeline.component.scss"],
  standalone: false,
})
export class CollectionTimelineComponent extends CollectionProjectSharedTimelineComponent {
  constructor(
    googleAnalyticsService: GoogleAnalyticsService,
    cdr: ChangeDetectorRef,
    flagService: FeatureFlagsService,
    public mapService: MapService,
  ) {
    super(googleAnalyticsService, cdr, flagService, mapService);
  }

  onChangeProject(value: number): void {
    const aoi = this._aois[value];

    // First update the filters
    this.updateFiltersByAOI(aoi);

    //Select the collection
    this.viewerService.showCollection(aoi);

    //maybe we can do just this
    this.viewerService.saveUserConfiguration(this.viewerService.getLayersToSaveConfiguration());
    this.sliderControl.reset(value);

    this.sendAnalyticsEvent(aoi);
  }
}
